import * as React from 'react';
import {reset} from 'redux-form';
import {Button, Col, Container, Row, Table} from 'reactstrap';
import {lazyInject, TYPES} from '../../../../utils/inversify-config';
import TableEditIcon from 'mdi-react/TableEditIcon';
import MiranaServiceClient from '../../../../middleware/mirana-client';
import Panel from '../../../../theme/components/Panel';
import {mirana} from '@wize/mirana-proto/mirana-proto';
import VisicoolerModeloModal from './visicooler-modelo-modal';
import {error, success} from '../../../../utils/notification-actions';
import {RouteComponentProps, withRouter} from 'react-router-dom';
import {Store} from 'react-redux';
import {FuerzasVenta, IFuerzaVenta} from '../../../../utils/constants';
import MiranaState from '../../../../reduxstore/mirana-state';

interface VisicoolersModeloState {
    modelosResponse?: mirana.IVisicoolerModelo[];
    modalOpen: boolean;
    selectedModelo?: mirana.IVisicoolerModelo;
    inNewMode: boolean;
    fuerzaVenta?: IFuerzaVenta;
}

class VisicoolersModelo extends React.Component<RouteComponentProps<any>, VisicoolersModeloState> {

    @lazyInject(TYPES.MIRANA_SERVICE)
    public apiClient: MiranaServiceClient;

    @lazyInject(TYPES.REDUX_STORE)
    public reduxStore: Store<MiranaState>;

    constructor(props) {
        super(props);
        this.state = {
            modalOpen: false,
            inNewMode: false,
        };
    }

    public componentWillReceiveProps(newProps) {
        let fuerzaVenta;
        for (const key in FuerzasVenta) {
            if (FuerzasVenta[key].abbrv === newProps.match.params.fuerzaVenta) {
                fuerzaVenta = FuerzasVenta[key];
            }
        }
        this.setState({fuerzaVenta});
        this.buscarModelos(fuerzaVenta ? fuerzaVenta.id : null);
    }

    public componentDidMount() {
        let fuerzaVenta;
        for (const key in FuerzasVenta) {
            if (FuerzasVenta[key].abbrv === this.props.match.params.fuerzaVenta) {
                fuerzaVenta = FuerzasVenta[key];
            }
        }
        this.setState({fuerzaVenta});
        this.buscarModelos(fuerzaVenta ? fuerzaVenta.id : null);
    }

    private buscarModelos = async (fuerzaVentaId: string) => {
        const response = await this.apiClient.filtrarVisicoolerModelos(fuerzaVentaId);
        this.setState({modelosResponse: response ? response.modelos : []});
    };

    private togleModal = () => {
        this.reduxStore.dispatch(reset('visicooler_modelo_form'));
        this.setState({modalOpen: !this.state.modalOpen, inNewMode: false});
    };

    private get modelos() {
        const content: any[] = [];
        if (this.state.modelosResponse) {
            this.state.modelosResponse.forEach((modelo, idx) => {
                content.push(
                    <tr key={idx}>
                        <td>{modelo.descripcion}</td>
                        <td style={{textAlign: 'center'}}>{modelo.cuota}</td>
                        <td style={{textAlign: 'center'}}>{modelo.estadoStr}</td>
                        <td style={{textAlign: 'center'}}>
                            <Button onClick={() => this.handleEditClick(modelo)} className='icon context-button'>
                                <TableEditIcon/>
                            </Button>
                        </td>
                    </tr>
                )
            });
        }
        return content;
    }

    private submitModeloForm = async (values) => {
        try {
            const body = mirana.VisicoolerModelo.create({
                fuerzaVentaId: this.state.fuerzaVenta ? this.state.fuerzaVenta.id : '',
                modeloId: values.modeloId,
                cuota: Number(values.cuota),
                estado: values.estado.value ? values.estado.value : values.estado,
                descripcion: values.descripcion
            });
            await this.apiClient.actualizarModelo(body);
            this.reduxStore.dispatch(success('Notificación', 'Información registrada correctamente'));
            await this.buscarModelos(this.state.fuerzaVenta ? this.state.fuerzaVenta.id : '');
        } catch (ex) {
            this.reduxStore.dispatch(error('Error', ex.response.data.message));
        } finally {
            this.togleModal();
        }
    };

    private handleNewClick = () => {
        this.togleModal();
        this.setState({selectedModelo: undefined, inNewMode: true});
    };

    private handleEditClick = (modelo: mirana.IVisicoolerModelo) => {
        this.setState({selectedModelo: modelo});
        this.togleModal();
    };

    public render() {
        return (
            <Container className='dashboard'>
                <Row>
                    <Col md={12}>
                        <h3 className='page-title'>{this.state.fuerzaVenta ? this.state.fuerzaVenta.descripcion : ''}:
                            Visicoolers Modelos</h3>
                    </Col>
                    <Col md={6} lg={6}>
                        <Panel xs={12} md={12} divider={true} title='Modelos'>
                            <Button color='success' className='rounded visicooler-add-button'
                                    onClick={this.handleNewClick}>+</Button>
                            <Table striped={true} className='table--bordered' responsive={true}>
                                <thead>
                                <tr>
                                    <th>Descripción</th>
                                    <th style={{textAlign: 'center'}}>Cuota</th>
                                    <th style={{textAlign: 'center'}}>Estado</th>
                                    <th style={{textAlign: 'center'}}>Editar</th>
                                </tr>
                                </thead>
                                <tbody>
                                {this.modelos}
                                </tbody>
                            </Table>
                        </Panel>
                    </Col>
                </Row>
                <VisicoolerModeloModal onSubmit={this.submitModeloForm} toggle={this.togleModal}
                                       inNewMode={this.state.inNewMode}
                                       modelo={this.state.selectedModelo}
                                       isOpen={this.state.modalOpen}/>
            </Container>
        );
    }
}

export default withRouter(VisicoolersModelo);


// WEBPACK FOOTER //
// ./src/components/pages/visicooler/modelos/visicooler-modelo.tsx